import { useContext } from 'react';
import { AuthContext } from '../contextos/authContext';
import TelaInformativa from './TelaInformativa';

import { CONSTANTES } from '../config/constantes'

export default function PrivateRoute({ children, acceptedRoles }) {

    console.log('INICIANDO PrivateRoute');
    // const { signed, loading, userRoles, permissoes, superUser } = useContext(AuthContext);
    const { signed, loading, permissoes, superUser } = useContext(AuthContext);

    if (loading) {
        return <div className='d-flex justify-content-center'>
            <p>Carregando...</p>
        </div>;
    }

    if (!signed) {
        return <TelaInformativa cabecalho='É PRECISO ESTAR LOGADO PARA ACESSAR ESSE RECURSO'
            mensagem='Clique no botão abaixo para retornar à tela de login'
            pathRedirect='https://web2.smsrio.org/'
            buttonMessage='Fazer login'
            urlExterna={true} />
    }

    let permissaoRota = null;
    if (superUser) {
        permissaoRota = true;
    } else {
        console.log(acceptedRoles);
        permissaoRota = permissoes.some(role => acceptedRoles.includes(role));
    }

    const msgNaoPermitido = `Caso necessite dessa permissão, envie um e-mail para ${CONSTANTES.EMAIL_ADMIN_NTM}. Clique no botão abaixo para retornar à tela inicial`

    if (!permissaoRota) {
        return <TelaInformativa cabecalho='VOCÊ NÃO TEM PERMISSÃO PARA ACESSAR ESTE RECURSO'
            mensagem={msgNaoPermitido}
            pathRedirect='/'
            buttonMessage='Voltar'
            urlExterna={false} />
    }

    return children;

}